module.exports = __webpack_public_path__ + "static/media/marketing.17d17389.svg";